/**
 * Footer brandmark scroll-velocity stretch.
 *
 * Mobile behavior:
 *  - window.scrollY + scroll events are supported on iOS Safari, mobile Chrome,
 *    and Android browsers (touch-momentum scroll fires standard scroll events).
 *  - Per-frame velocity (y - lastY) stays small during touch momentum, naturally
 *    producing a gentler effect on phones than mouse-wheel on desktop.
 *  - The CSS variable --stretch-max (set in brand-identity.css media query at
 *    < 750px) further caps mobile pull at 0.22 vs 0.45 desktop.
 *  - prefers-reduced-motion disables the effect entirely (a11y).
 *  - RAF loop self-suspends after 30 idle frames to preserve battery.
 */
(function () {
  var el = document.querySelector('.footer__brandmark-img');
  if (!el || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var lastY = window.scrollY,
    velocity = 0,
    target = 1,
    current = 1,
    raf = null,
    idle = 0;
  function tick() {
    var y = window.scrollY;
    velocity = y - lastY;
    lastY = y;
    var maxPull = parseFloat(getComputedStyle(el).getPropertyValue('--stretch-max')) || 0.45;
    var pull = Math.min(maxPull, Math.abs(velocity) * 0.012);
    target = 1 + pull;
    current += (target - current) * 0.18;
    target += (1 - target) * 0.10;
    el.style.setProperty('--stretch-y', current.toFixed(3));
    if (Math.abs(current - 1) < 0.001 && Math.abs(velocity) < 0.5) {
      idle++;
    } else {
      idle = 0;
    }
    if (idle < 30) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = null;
    }
  }
  function start() {
    if (raf) return;
    idle = 0;
    lastY = window.scrollY;
    raf = requestAnimationFrame(tick);
  }
  window.addEventListener('scroll', start, { passive: true });
  start();
})();
